<script>

export default {
  functional: true,
  props: {
    headers: Array,
    handleSort: Function,
    pagination: Object,
    hasActions: Boolean,
  },
  render: (h, { props }) => {
    const { headers, handleSort, pagination, hasActions } = props
    const tdClass = (header) => ({
      'column': true,
      'sortable': true,
      'px-1': true,
      'desc': pagination.descending,
      'asc': !pagination.descending,
      'text-xs-right': header['align'] === 'right',
      'text-xs-left': header['align'] !== 'right',
      'active': header.orig ? header.orig === pagination.sortBy : header.value === pagination.sortBy,
    })
    let dataFields = headers.map((header, idx) => {
      const doSort = e => {
        handleSort(header.orig ? header.orig : header.value)
      }
      return (
        <th key={ idx } class={ tdClass(header) } on-click={ doSort }>
          { header.label }
          <v-icon small>arrow_upward</v-icon>
        </th>
      )
    })
    let actionColumn = hasActions
      ? <th class="mx-0 px-0 text-xs-right">Actions</th>
      : ''

    return (
      <tr>
        <th class="">{''}</th>
        { dataFields }
        { actionColumn }
      </tr>
    )
  },
}
</script>
